module.exports = __webpack_public_path__ + "static/media/helpIconPrimary.1cc7b44d.svg";